import React from "react";
import { Link } from "react-router-dom";
import { withBem } from "../hocs";
import { Grid, Row, Col } from "./layout";
import footerLogoImg from "assets/images/footer-logo.svg";
import moment from "moment";

const Footer = ({ cn }) => (
  <footer className={cn()}>
    <Grid>
      <Row>
        <Col sm={6} className={cn("col")}>
          <div className={cn("address-info-wrapper")}>
            <div className={cn("logo")}>
              <img src={footerLogoImg} title="King Street Apps Logo" />
            </div>
            <span>
              Suite 202,
              <br />
              Chiswick Works,
              <br />
              100 Bollo Lane
              <br />
              London W45LX
              <br />
            </span>
          </div>
        </Col>
        <Col sm={6} lg={3} className={cn("col")}>
          <span>
            <a href="mailto:letsmake@kingstreetapps.com">
              letsmake@kingstreetapps.com
            </a>
            <br />
            <a href="tel:+44793177882">+44 7931 77882</a>
            <br />
            @kingstreetapps
          </span>
        </Col>
        <Col sm={6} lg={3} className={cn("col")}>
          <span>{`© ${moment().year()} King Street Apps Ltd`}</span>
        </Col>
      </Row>
    </Grid>
  </footer>
);

export default withBem("footer")(Footer);
